// composables/useThrottleFn.ts
export function useThrottleFn(fn: (...args: any[]) => void, delay: number = 200) {
    let throttleTimeout: ReturnType<typeof setTimeout> | null = null;

    const throttledFn = (...args: any[]) => {
        if (throttleTimeout) return;

        throttleTimeout = setTimeout(() => {
            throttleTimeout = null;
            fn(...args);
        }, delay);
    };

    return throttledFn;
}
